/*
 * @Author: renjie.yin
 * @Date: 2022-11-09 13:59:21
 * @LastEditors: renjie.yin
 * @LastEditTime: 2022-11-15 10:40:30
 * @Description:
 */
import { buildTree as _buildTree } from '../../utils'
import { TablePipeline } from '../pipeline'

export function buildTree(idProp: string, parentIdProp: string) {
  return (pipeline: TablePipeline) => pipeline.mapDataSource(rows => _buildTree(idProp, parentIdProp, rows))
}
